import {
  renderStructuredElements,
  reRenderStructuredElements,
} from "@/utils/render-helpers.jsx";
import Search from "@/components/Search";
document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("search", Search);
});
document.addEventListener("react:reload", () => {
  reRenderStructuredElements("search", Search);
});
